import {IToJson} from '@toolify/client/src/types/IToJson'

import {
  ICallResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/ICallResponseInstance'
import {mapResponseEntity} from '@toolify/client/src/modules/api/singletons/mapResponseEntity'

export function mapCallResponseInstance(
  call: IToJson<ICallResponseInstance>,
): ICallResponseInstance {
  return {
    ...call,
    createdAt: new Date(call.createdAt),
    endedAt: call.endedAt ? new Date(call.endedAt) : null,
    recordingStartedAt: call.recordingStartedAt ? new Date(call.recordingStartedAt) : null,
    authorEntity: mapResponseEntity(call.authorEntity),
    limitedParticipantsWithAttributes: call.limitedParticipantsWithAttributes?.map(participant => {
      return {
        entity: mapResponseEntity(participant.entity),
        attributes: participant.attributes,
      }
    }) || [],
  }
}
